import styles from './styles.scss';
import { ReactNode } from 'react';
import cn from 'classnames';

interface Props {
  children: ReactNode;
  className?: string;
}
export const Level = ({ children, className }: Props) => (
  <div className={cn(styles.level, className)}>{children}</div>
);
